/**
 * Maximum number of passengers supported in the Quick Purchase flow.
 * @type {number}
 */
// eslint-disable-next-line import/prefer-default-export
export const MAX_QUICK_PURCHASE_PASSENGERS = 2;
